import { generateLocale } from './generate.js';

export default generateLocale([
  '닉네임',
  '닉네임은 3바이트 이상이어야 합니다.',
  '이메일',
  '이메일 주소를 확인해 주세요.',
  '웹사이트',
  '선택사항',
  '여기에 댓글을 입력하세요...',
  '아직 댓글이 없습니다.',
  '제출',
  '좋아요',
  '좋아요 취소',
  '답글',
  '답글 취소',
  '댓글',
  '새로고침',
  '더 보기...',
  '미리보기',
  '이모지',
  '이미지 업로드',
  '초 전',
  '분 전',
  '시간 전',
  '일 전',
  '방금 전',
  '업로드 중',
  '로그인',
  '로그아웃',
  '관리자',
  '고정',
  '글자 수',
  '댓글은 $0자에서 $1자 사이여야 합니다!\n현재 글자 수: $2',
  '익명',
  '난쟁이',
  '호빗',
  '엔트',
  '마법사',
  '엘프',
  '마이아',
  'GIF',
  'GIF 검색',
  '프로필',
  '승인됨',
  '대기 중',
  '스팸',
  '고정 해제',
  '오래된 순',
  '최신 순',
  '인기순',
  '어떻게 생각하시나요?',
  '댓글이 검토 중이며 현재 본인만 볼 수 있습니다. 승인 후 공개됩니다.',
  '이 게시물의 댓글 구독',
  '이 사이트의 댓글 구독',
  '댓글에 대한 답글 구독',
]);
